<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <radio-question [data]="parkingDisc.data" [active]="parkingDisc.active"
                    [valueSelected]="parkingDisc.valueSelected"
                    (selectAnswer)="onParkingDiscSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <radio-question [data]="reconsider.data" [active]="parkingDisc.valueSelected !== '0'"
                    [valueSelected]="reconsider.valueSelected"
                    (selectAnswer)="onReconsiderSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <select-question [data]="cancellation.data" [active]="parkingDisc.valueSelected !== '0' && reconsider.valueSelected === 'y'"
                     [valueSelected]="cancellation.valueSelected"
                     (selectAnswer)="onCancellationSelected($event)"></select-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">4</i>
    <div class="default-text large" [innerHTML]="textCopy.errorTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.errorSubtitle"></div>
    <br/>
    <div class="default-text"><strong>{{textCopy.errorListTitle}}</strong></div>
    <multiple-select-question [data]="errorsMultipleQuestions.data" [active]="parkingDisc.valueSelected !== '0' && reconsider.valueSelected === 'y'"
                              [valuesSelected]="errorsMultipleQuestions.valuesSelected"
                              (selectAnswer)="onErrorsMultipleQuestionsSelected($event)"></multiple-select-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">5</i>
    <explain-question [data]="explain.data" [active]="parkingDisc.valueSelected !== '0'"
                 [valueSelected]="explain.valueSelected"
                  [validationSelected]="explain.validationSelected"
                  [validationText]="explain.validationText"
                 (selectAnswer)="onExplainQuestionSelected($event)"></explain-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
